import React from 'react'

import HintPopover from "../../../../core/gd-ui/hint-popover/hint-popover"
import stopPropagation from '../../../../core/gd/utils/stop-propagation'
import ControlButtonStandard from "../../../../core/gd-components/buttons/control-button/control-button-standard"

// const debug = "AppControlShare"
const debug = false

type Props = {
    className?  : string

    type        : 'default'|'header-v2',
    app         : any
}

export default class AppControlShare extends React.Component<Props> {

    static defaultProps = {
        type: 'default'
    }

    onClick = () => {
        this.props.app.shareView.openModal()
    }

    onClickUpgrade = () => {
        gd.modals.other.upgradeToPro()
    }

    render() {
        if (!gd.ac.check.canShareView()) {
            return false
        }

        let isEditable = true

        debug && console.log(debug, 'render', this.props.app.projectId, this.props.app.projectCollectionId, this.props.app)

        /** PROJECT VIEW **/
        if (this.props.app.projectId) {
            // no share view for templates
            const project = gd.session.projects.get(this.props.app.projectId)
            if (project && project.isTemplate) return false

            // project share view only for full access users
            isEditable = !project || gd.ac.check.project.fullAccess(project.id, project)
        }

        /** PORTFOLIO VIEW **/
        if (this.props.app.projectCollectionId) {
            const projectCollection = gd.session.projectCollections.get(this.props.app.projectCollectionId)

            // portfolio share view only for full or editor access users
            isEditable = !projectCollection || projectCollection.isEditorAccessUser
        }

        // no share view if read only
        const isReadOnly = this.props.app.manager && !_.isNil(this.props.app.manager.isReadOnly) ? this.props.app.manager.isReadOnly : false

        const disabled = isReadOnly || !isEditable

        const isSelected = !!this.props.app.shareView?.sharedViewId
        const isPro = gd.company.license.isPro

        const hint = isSelected ? "Edit Shared View" : "Share View"
        const showLabel = this.props.type === 'header-v2'

        debug && console.log(debug, 'render', isSelected, this.props.app.shareView)

        return (
            <ControlButtonStandard className    = {this.props.className}
                                   isSelected   = {!disabled && isSelected}
                                   isDisabled   = {disabled}
                                   onClick      = {disabled ? stopPropagation : isPro ? this.onClick : this.onClickUpgrade}>
                <div className="i5-share"/>
                {showLabel && <div className="label">Share</div>}
                <HintPopover parent={this} hint={hint}/>
            </ControlButtonStandard>
        )
    }
}